import { memo } from 'react';

import { Flex } from '@/components/core';
import {
  TriggerAPIConfiguration,
  TriggerEmailConfiguration,
  TriggerN8NConfiguration,
  TriggerPanelHeader,
  TriggerPowerAutomateConfiguration,
  TriggerZapierConfiguration,
} from '@/components/flow';
import {
  CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { useSuspenseGetAction } from '@/hooks/api';
import { TriggerProvider } from '@/store';

export type TriggerPanelProps = {
  agentId: string;
  actionId: string;
};

const ITriggerPanel = ({ agentId, actionId }: TriggerPanelProps) => {
  const { data: action } = useSuspenseGetAction({ actionId });

  return (
    /* Force remount of component when agentId or actionId changes */
    <Flex col key={`${agentId}/${actionId}`} className="w-full">
      <TriggerProvider action={action}>
        <TriggerPanelHeader className="border-b border-gray-200 p-4" actionId={actionId} />
        {action.functionId === CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID ? (
          <TriggerEmailConfiguration />
        ) : action.functionId === CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID ? (
          <TriggerPowerAutomateConfiguration />
        ) : action.functionId === CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID ? (
          <TriggerZapierConfiguration />
        ) : action.functionId === CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID ? (
          <TriggerN8NConfiguration />
        ) : action.functionId === CREATE_AGENT_RUN_FROM_API_FUNCTION_ID ? (
          <TriggerAPIConfiguration />
        ) : null}
      </TriggerProvider>
    </Flex>
  );
};

export const TriggerPanel = memo(ITriggerPanel) as typeof ITriggerPanel;
